import * as React from 'react';
import { Box, Typography, useTheme } from '@mui/material';

import { IZoneCleaningHistoryItemView } from 'models';

import { ZoneCleaningHistoryItemCard } from './zone-cleaning-history-item-card';
import { Loading } from './loading';

interface ZoneCleaningHistoryProps {
  date: string;
  data: Array<IZoneCleaningHistoryItemView>;
  loading: boolean;
}

export const ZoneCleaningHistory = ({ date, data, loading }: ZoneCleaningHistoryProps) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        border: `1px solid ${theme.palette.text.secondary}`,
        borderRadius: 1,
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        paddingX: 4,
        paddingY: 8,
        maxWidth: theme.breakpoints.values.md,
      }}
    >
      <Box>
        <Typography
          sx={{
            fontSize: 18,
            fontWeight: 500,
            marginLeft: 'auto',
            textAlign: 'center',
          }}
        >
          {date}
        </Typography>

        {loading ? (
          <Loading text="Loading Cleaning History..." height={200} />
        ) : data.length > 0 ? (
          <>
            {data.map((item, index) => (
              <Box
                key={`zone-history-item-card-${index}`}
                sx={{
                  position: 'relative',
                  paddingY: 3.5,
                }}
              >
                <Box
                  sx={
                    index === 0
                      ? {
                          position: 'absolute',
                          bottom: 0,
                          left: 33,
                          height: '50%',
                        }
                      : index === data.length - 1
                      ? {
                          position: 'absolute',
                          top: 0,
                          left: 33,
                          height: '50%',
                        }
                      : {
                          position: 'absolute',
                          top: 0,
                          left: 33,
                          height: '100%',
                        }
                  }
                >
                  <Box
                    sx={{
                      width: 2,
                      height: '100%',
                      bgcolor: '#C4C4C4',
                    }}
                  />
                </Box>

                <Box
                  sx={{
                    position: 'relative',
                  }}
                >
                  <ZoneCleaningHistoryItemCard date={date} item={item} />
                </Box>
              </Box>
            ))}
          </>
        ) : (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              height: 200,
            }}
          >
            <Typography color="textSecondary" variant="body2">
              No cleaning history
            </Typography>
          </Box>
        )}
      </Box>
    </Box>
  );
};
